/**
 * Orchestra AI Platform - Scenarios Wrapper
 * 
 * Wrapper component for the Scenario Browser that works with tab-based navigation
 */

import { ScenarioBrowser } from '../Scenarios/ScenarioBrowser';
import PropTypes from 'prop-types';

/**
 * Orchestra Scenarios Component
 * @param {Object} props
 * @param {Object} props.currentUser - Current user object
 * @param {Function} props.onBack - Back navigation handler
 * @param {Function} props.onTabChange - Tab change handler
 */
export function OrchestraScenarios({ currentUser, onBack, onTabChange }) {
  return (
    <div style={{ padding: '20px', height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1 style={{ fontSize: '24px', fontWeight: 'bold', color: '#1f2937' }}>
          🎓 Orchestra AI Platform - 教育場景範本
        </h1>
        <button
          onClick={onBack}
          style={{
            padding: '8px 16px',
            backgroundColor: '#6b7280',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        >
          ← 返回
        </button>
      </div>

      <div style={{ flex: 1, overflow: 'auto' }}>
        <ScenarioBrowser
          onScenarioSelect={(scenarioId) => {
            // Navigate to scenario detail or workflow builder
            onTabChange('scenario-detail', { scenarioId });
          }}
          onTabChange={onTabChange}
        />
      </div>
    </div>
  );
}

OrchestraScenarios.propTypes = {
  currentUser: PropTypes.object,
  onBack: PropTypes.func.isRequired,
  onTabChange: PropTypes.func.isRequired,
};

